export type BulkSearchStatus = 'QUEUED' | 'RUNNING' | 'READY' | 'ERROR';

/** Mirror of Java `com.lansa.lax.pim.BulkSearch`. */
export interface BulkSearch {
    id: number;
    name?: string;
    attributeName?: string;
    exactSearch?: boolean;
    finished?: boolean;
    status?: BulkSearchStatus;
    user?: string;
}

/**
 * Spinner belongs on QUEUED / RUNNING only. Angular's `bulkSearchChanged`
 * handler leaves `$rootScope.bulkSearchLoading` true when status is READY
 * but `finished` is missing from the payload.
 */
export function isBulkSearchInProgress(bulkSearch: BulkSearch | null | undefined): boolean {
    if (!bulkSearch) {
        return false;
    }
    if (bulkSearch.status === 'READY' || bulkSearch.status === 'ERROR') {
        return false;
    }
    if (bulkSearch.finished === true) {
        return false;
    }
    return true;
}

export type BulkSearchMatchPrecision = 'exact' | 'prefix' | 'infix';

export interface BulkSearchDialogState {
    queryValues?: string;
    queryTooLong?: number;
}
